import { graphql } from '../../generated';

export const ORDER_ITEM_GROUPS = graphql(`
  query OrderItemGroupsQuery($id: ID!) {
    order(id: $id) {
      id
      itemGroups {
        id
        itemIds
        count
        deliveryId
        invalidated
        productId
        discountAmount
        refundingIds
        refundedByIds
        invalidatingIds
        invalidatedByIds
        productVariantId
        shop {
          id
          name
        }
        discountAmount
        voucherCode {
          id
          code
          voucherCampaign {
            id
            title
            amount
            discountType
          }
        }
        product {
          artist
          description
          id
          name
          sku
          dhlShippingFrom
          ... on MerchProduct {
            productType
            color
          }
          personalizationRequirement
          taxesPerCountry
        }
        productVariant {
          id
          sku
          description
          ean
          physical
          weight
          legacyId
        }
        sku
        permissions {
          id
          refund
          remove
          changeDelivery
          changeInvoice
        }
        ... on OutgoingItemGroup {
          invoiceId
          price
          vat
          vatPercentage
          total
          invalidated
          tickets {
            id
            url
            validationCode
            ticketPassword
            personalIdentifier
            validatedBy
            usedAt
            passbook {
              id
              url
            }
            seat {
              venueSection {
                name
              }
              name
              row
            }
            resaleOffer {
              code
              status
              public
              privateUrl
              newOrderId
              newOrderReference
            }
            resoldByOffer {
              originalOrderId
              originalOrderReference
              soldItemValidationCode
            }
            permissions {
              id
              offerForResale
            }
            resaleAvailability
          }
        }
      }
    }
  }
`);
